export default "__VITE_ASSET__Cjs5$_gE__"